import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { PopupTooltip, Button, Icon } from '@adc/ui-core'
import { TutorialTooltipGroupContext } from '../util/contexts'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const BASE_ELM_ID = 'tooltip_item'
const TOP_CENTER = 'top center'

class TutorialTooltipGroupItem extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    header: PropTypes.node,
    content: PropTypes.node.isRequired,
    position: PropTypes.string,
    noActions: PropTypes.bool,
    skip: PropTypes.bool,
    elmId: PropTypes.string,
  }

  static defaultProps = {
    position: TOP_CENTER,
    elmId: 'tutorial',
    noActions: false,
  }

  static contextType = TutorialTooltipGroupContext

  tooltipHeader = () => (
    <div className={cx('tooltip-header-root', 'u-mb-2')}>
      <div className={cx('tooltip-header')}>{this.props.header}</div>
      {!this.props.noActions && (
        <div className={cx('tooltip-close-root')}>
          <Icon
            name='times'
            size='large'
            color='white'
            iconStyle='light'
            data-elm-id={`${this.props.elmId}_${BASE_ELM_ID}_close_icon`}
            className={cx('tooltip-close-icon')}
            onClick={this.context.handleClose}
          />
        </div>
      )}
    </div>
  )

  tooltipContent = () => (
    <>
      <div className={cx('tooltip-content')}>{this.props.content}</div>
      {!this.props.noActions && (
        <div className='u-mt-4'>
          <Button
            size='small'
            role='primary'
            className={cx('tooltip-next-button')}
            elmId={`${this.props.elmId}_${BASE_ELM_ID}_next_button`}
            onClick={this.context.handleNext}
          >
            Next
          </Button>
          <span className={cx('tooltip-tutorial-status')}>
            {this.context.tutorialStatus.current} of{' '}
            {this.context.tutorialStatus.total}
          </span>
        </div>
      )}
    </>
  )

  render() {
    const { children, position, elmId, skip = false } = this.props
    const { showTooltip } = this.context

    return showTooltip && !skip ? (
      <PopupTooltip
        open
        pinned
        trigger={children}
        position={position}
        header={this.tooltipHeader}
        content={this.tooltipContent}
        data-elm-id={`${elmId}_${BASE_ELM_ID}`}
        className={cx('tooltip-root', 'blue-tooltip')}
        wide
      />
    ) : (
      children
    )
  }
}

export default TutorialTooltipGroupItem
